// ملف الترجمة الخاص باللغة العربية
// نظّم المفاتيح حسب الصفحة/الميزة عشان تكون سهلة اللقاء والتوسّع لاحقًا

const ar = {
    common: {
        or: "أو",
        loading: "جاري التحميل...",
        save: "حفظ",
        cancel: "إلغاء",
        confirm: "تأكيد",
        back: "رجوع",
        edit: "تعديل",
        delete: "حذف",
        add: "إضافة",
        search: "بحث",
        submit: "إرسال",
        yes: "نعم",
        no: "لا",
    },

    nav: {
        home: "الرئيسية",
        categories: "الأقسام",
        products: "المنتجات",
        cart: "السلة",
        dashboard: "لوحة التحكم",
        logout: "تسجيل الخروج",
        login: "تسجيل الدخول",
    },

    orders: {
        // ... باقي المفاتيح الموجودة عندك بالفعل زي pageTitle, orderNumber, status...

        paymentStatus: {
            paid: "تم الدفع ✓",
            not_required: "الدفع عند الاستلام",
            pending: "بانتظار الدفع",
            failed: "فشل الدفع",

        },
        pageTitle: "طلباتي",
        backToProfile: "الرجوع للبروفايل",
        noOrders: "لا توجد طلبات سابقة",
        browseShop: "تصفح المتجر",
        loginRequiredTitle: "سجّل الدخول لعرض طلباتك",
        loginCta: "تسجيل الدخول",
        orderNumber: "طلب #{{id}}",
        total: "الإجمالي",
        notFound: "الطلب غير موجود",
        confirmCancel: "هل أنت متأكد من إلغاء هذا الطلب؟",
        cancelOrder: "إلغاء الطلب",
        cancelling: "جارِ الإلغاء...",
        cancelError: "تعذر إلغاء الطلب",
        // -------------------- تمت الإضافة: بيانات تتبع الشحنة --------------------
        trackingTitle: "معلومات الشحنة",
        carrier: "شركة الشحن",
        trackingNumber: "رقم التتبع",
        trackShipment: "تتبع الشحنة",
        status: {
            pending: "قيد الانتظار",
            processing: "قيد التجهيز",
            shipped: "تم الشحن",
            delivered: "تم التسليم",
            cancelled: "ملغي",
        },
    },
    auth: {
        loginTab: "تسجيل الدخول",
        registerTab: "إنشاء حساب",

        brandMark: "متجرنا",
        discountTag: "خصم",
        welcomeBackTitle: "سعداء بعودتك",
        welcomeBackDesc: "سجّل الدخول لمتابعة طلباتك والاستفادة من عروضك الخاصة.",
        joinStoreTitle: "انضم إلى المتجر",
        joinStoreDesc: "أنشئ حسابك في أقل من دقيقة، واستفد من عروض الأعضاء الجدد.",

        perkDelivery: "توصيل سريع لجميع المناطق",
        perkOffers: "عروض حصرية لأصحاب الحسابات",
        perkReturns: "إرجاع مجاني خلال 14 يوماً",

        nameLabel: "الاسم الكامل",
        emailLabel: "البريد الإلكتروني",
        passwordLabel: "كلمة المرور",

        loginButton: "تسجيل الدخول",
        registerButton: "إنشاء الحساب",
        continueWithGoogle: "المتابعة عبر Google",

        noAccount: "ليس لديك حساب؟ ",
        createOne: "أنشئ واحداً الآن",
        haveAccount: "لديك حساب بالفعل؟ ",
        loginNow: "سجّل الدخول",

        loggingOut: "جاري تسجيل الخروج...",
        logoutButton: "تسجيل الخروج",

        googleLoadingTitle: "جاري تسجيل الدخول عبر Google",
        googleLoadingDesc: "لحظات ويتم تحويلك تلقائياً...",
        googleErrorTitle: "تعذر تسجيل الدخول",
        googleErrorDesc: "حدث خطأ أثناء التحقق من حسابك على Google.",
        backToLogin: "العودة لصفحة الدخول",
    },

    errors: {
        invalidCredentials: "البريد الإلكتروني أو كلمة المرور غير صحيحة",
        emailTaken: "هذا البريد الإلكتروني مستخدم بالفعل",
        serverError: "حدث خطأ في الخادم، حاول مرة أخرى",
        networkError: "تعذر الاتصال بالخادم، تحقق من الإنترنت",
        logoutFailed: "تعذر تسجيل الخروج، حاول مرة أخرى",
        notFoundTitle: "الصفحة غير موجودة",
        notFoundSubtitle: "يبدو إنك تهت شوية! الصفحة اللي بتدوّر عليها مش موجودة أو اتنقلت مكان تاني.",
        notFoundCta: "العودة للرئيسية",
        forbiddenTitle: "غير مصرح لك بالوصول لهذه الصفحة",
    },

    brand: {
        name: "متجرنا الإلكتروني",
    },

    dashboardNav: {
        users: "المستخدمون",
        addUser: "إضافة مستخدم",
        categories: "الأقسام",
        addCategories: "إضافة قسم",
        products: "المنتجات",
        addProducts: "إضافة منتج",
        writer: "الكاتب",
        orders: "الطلبات",
    },

    table: {
        action: "إجراء",
        searchPlaceholder: "ابحث هنا",
        rowsPerPage: "عدد الصفوف",
        loading: "جاري التحميل...",
        searching: "جاري البحث...",
        you: "أنت",
    },

    roles: {
        "1995": "مدير",
        "1996": "كاتب",
        "1999": "مسؤول منتجات",
        "2001": "مستخدم",
    },

    usersPage: {
        eyebrow: "لوحة التحكم",
        title: "المستخدمون",
        addButton: "إضافة مستخدم",
        columnName: "الاسم",
        columnEmail: "البريد الإلكتروني",
        columnRole: "الدور",
        columnCreated: "تاريخ الإنشاء",
        columnLastLogin: "آخر تسجيل دخول",
    },

    products: {
        addTitle: "إضافة منتج",
        editTitle: "تعديل منتج",
        categoryLabel: "القسم",
        selectCategory: "اختر قسم",
        titleLabel: "العنوان",
        titlePlaceholder: "اكتب عنوان المنتج",
        descriptionLabel: "الوصف",
        descriptionPlaceholder: "اكتب وصف المنتج",
        priceLabel: "السعر",
        pricePlaceholder: "اكتب السعر",
        discountLabel: "الخصم",
        discountPlaceholder: "اكتب نسبة الخصم",
        aboutLabel: "تفاصيل إضافية",
        aboutPlaceholder: "اكتب تفاصيل إضافية",
        stockLabel: "الكمية المتوفرة",
        stockPlaceholder: "اكتب الكمية",
        imagesLabel: "الصور",
        uploadHere: "اضغط هنا لرفع الصور",
        save: "حفظ",
        deleteImage: "حذف",
        pageTitle: "المنتجات",
        addButton: "إضافة منتج",
        columnTitle: "العنوان",
        columnImages: "الصور",
        columnDescription: "الوصف",
        columnPrice: "السعر",
        columnRating: "التقييم",
        columnCreated: "تاريخ الإنشاء",
        columnUpdated: "آخر تحديث",
    },

    categories: {
        addTitle: "إضافة قسم",
        editTitle: "تعديل قسم",
        titleLabel: "العنوان",
        titlePlaceholder: "اكتب عنوان القسم",
        imageLabel: "الصورة",
        save: "حفظ",
        pageTitle: "الأقسام",
        addButton: "إضافة قسم",
        columnTitle: "العنوان",
        columnImage: "الصورة",
        columnCreated: "تاريخ الإنشاء",
        columnUpdated: "آخر تحديث",
    },

    usersForm: {
        addTitle: "إضافة مستخدم",
        editTitle: "تعديل مستخدم",
        nameLabel: "الاسم",
        namePlaceholder: "اكتب الاسم",
        emailLabel: "البريد الإلكتروني",
        emailPlaceholder: "اكتب البريد الإلكتروني",
        passwordLabel: "كلمة المرور",
        passwordPlaceholder: "اكتب كلمة المرور",
        roleLabel: "الدور",
        selectRole: "اختر الدور",
        save: "حفظ",
        submit: "إرسال",
    },

    footer: {
        rights: "© 2025 جميع الحقوق محفوظة لشركتك",
    },

    storefrontNav: {
        searchPlaceholder: "ابحث عن منتج",
        allCategories: "الكل",
        cartTitle: "السلة",
        emptyCart: "سلتك فارغة",
        close: "إغلاق",
        checkout: "إتمام الشراء",
    },

    search: {
        resultsFor: "نتائج البحث عن",
        noResults: "مفيش نتائج مطابقة لبحثك",
        subtitle: "جرب كلمات مختلفة أو أعم",
    },

    profile: {
        title: "الملف الشخصي",
        nameLabel: "الاسم",
        emailLabel: "البريد الإلكتروني",
        roleLabel: "نوع الحساب",
        logout: "تسجيل الخروج",
        notLoggedInTitle: "لسه مسجّلتش دخول",
        notLoggedInSubtitle: "سجّل دخولك عشان تقدر تشوف بياناتك وتتابع طلباتك",
        loginCta: "تسجيل الدخول",

        tabInfo: "البيانات الشخصية",
        tabCart: "السلة",
        tabWishlist: "المفضلة",
        tabOrders: "طلباتي",

        phoneLabel: "الهاتف",
        joinedLabel: "تاريخ الانضمام",

        emptyCart: "السلة فارغة حاليًا",
        emptyWishlist: "لا توجد منتجات في المفضلة",
        noOrders: "لا توجد طلبات سابقة",
        browseShop: "تصفح المتجر",

        total: "الإجمالي",
        loading: "جارِ التحميل...",
        viewAllOrders: "عرض كل طلباتي",
        continueToCheckout: "متابعة إلى تأكيد الطلب",
    },

    hero: {
        slide1Badge: "خصم %30",
        slide1LeftLabel: "على طلبك الأونلاين",
        slide1Eyebrow: "تشكيلة جديدة",
        slide1Title: "أناقتك تبدأ من هنا",
        slide1Subtitle: "أحدث صيحات الموضة والإكسسوارات بجودة عالية وأسعار تناسبك",
        slide2Badge: "عرض محدود",
        slide2LeftLabel: "لفترة محدودة فقط",
        slide2Eyebrow: "عروض محدودة",
        slide2Title: "خصومات تصل إلى 50٪",
        slide2Subtitle: "لفترة محدودة على تشكيلة مختارة من المنتجات",
        cta: "تسوّق الآن",
    },

    sections: {
        latestSalesTitle: "أحدث العروض",
        latestSalesSubtitle: "أفضل الأسعار لفترة محدودة",
        latestProductsTitle: "أحدث المنتجات",
        latestProductsSubtitle: "وصل حديثًا إلى المتجر",
        topRelatedTitle: "الأعلى تقييمًا",
        topRelatedSubtitle: "اختيارات العملاء المفضّلة",
    },

    product: {
        saleBadge: "عرض",
    },

    singleProduct: {
        home: "الرئيسية",
        noImages: "لا توجد صور لعرضها",
        onlyOneLeft: "متبقي قطعة واحدة فقط",
        addToCart: "أضف إلى السلة",
        addingToCart: "جاري الإضافة...",
        addedToCart: "تمت الإضافة ✓",
        stockAlert: "الكمية المطلوبة أكبر من المتوفر في المخزون",
        wishlistAdd: "إضافة للمفضلة",
        wishlistRemove: "إزالة من المفضلة",
        about: "نبذة",
        description: "الوصف",
    },

    categoriesPage: {
        title: "كل الأقسام",
        subtitle: "تصفّح المنتجات حسب القسم اللي يهمّك",
        noProducts: "مفيش منتجات في القسم ده لحد دلوقتي",
    },

    // -------------------- صفحة تأكيد الطلب (Checkout) --------------------
    checkout: {
        pageTitle: "مراجعة الطلب",
        confirmBtn: "تأكيد الطلب",
        confirming: "جارِ تأكيد الطلب...",
        total: "الإجمالي",
        editCartNote: "لتعديل الكميات أو حذف منتج،",
        backToCart: "ارجع لصفحة السلة",
        backToProduct: "رجوع لصفحة المنتج",
        emptyCart: "السلة فارغة، لا يوجد ما يمكن تأكيده",
        browseShop: "تصفح المتجر",
        productUnavailable: "المنتج غير متاح",
        genericError: "حدث خطأ أثناء إتمام الطلب، حاول مرة أخرى",
        shippingTitle: "عنوان الشحن",
        phonePlaceholder: "رقم الهاتف",
        cityPlaceholder: "المدينة",
        addressPlaceholder: "العنوان بالتفصيل (الحي، الشارع، رقم المبنى...)",
        notesPlaceholder: "ملاحظات إضافية (اختياري)",
        missingAddress: "من فضلك أكمل بيانات الشحن (الهاتف، المدينة، العنوان)",
        payCod: "الدفع عند الاستلام",
        payOnline: "بطاقة/محفظة إلكترونية",
        payOnlineSoon: "قريبًا",
        orderCreatedAwaitingPayment: "تم إنشاء الطلب #{{id}} — أكمل الدفع بالأسفل لتأكيده",
        verifyingPayment: "جارِ التحقق من الدفع...",
        paymentSuccess: "تم الدفع بنجاح 🎉",
        paymentFailed: "فشلت عملية الدفع",
        redirecting: "جارِ تحويلك إلى طلبك...",
    },

    // -------------------- لوحة تحكم: إدارة الطلبات --------------------
    adminOrders: {
        pageTitle: "إدارة الطلبات",
        pageSubtitle: "عرض كل طلبات العملاء وتحديث حالتها",
        searchPlaceholder: "ابحث برقم الطلب أو اسم/إيميل العميل...",
        searchBtn: "بحث",
        allStatuses: "كل الحالات",
        loading: "جارِ التحميل...",
        noResults: "لا توجد طلبات مطابقة",
        colOrderId: "#",
        colCustomer: "العميل",
        colItemsCount: "عدد المنتجات",
        colTotal: "الإجمالي",
        colDate: "التاريخ",
        colStatus: "الحالة",
        // -------------------- تمت الإضافة: عمود الدفع --------------------
        colPayment: "الدفع",
        details: "التفاصيل",
        hide: "إخفاء",
        prev: "السابق",
        next: "التالي",
        updateError: "تعذر تحديث حالة الطلب",
        // -------------------- تمت الإضافة: نموذج بيانات الشحن --------------------
        trackingTitle: "معلومات الشحنة",
        carrierPlaceholder: "اسم شركة الشحن (مثلاً: أرامكس)",
        trackingNumberPlaceholder: "رقم التتبع",
        trackingUrlPlaceholder: "رابط تتبع الشحنة (اختياري)",
        saveTracking: "حفظ بيانات الشحن",
        saving: "جارِ الحفظ...",
        trackingUpdateError: "تعذر حفظ بيانات الشحن",
        status: {
            pending: "قيد الانتظار",
            processing: "قيد التجهيز",
            shipped: "تم الشحن",
            delivered: "تم التسليم",
            cancelled: "ملغي",
        },
    },

    // -------------------- عام --------------------
    currency: "ر.س",
};

export default ar;
